const DESKTOP_ACCORDION = [
  {
    type: "FinerDetails",
    text: "THE FINER DETAILS",
    keyToBeChecked: "finerDetails",
    isShown: true,
  },
  {
    type: "ManufacturerDetails",
    text: "Manufacturer Details",
    keyToBeChecked: "manufacturerDetails",
    isShown: true,
  },
  {
    type: "About",
    text: "About %brand%",
    keyToBeChecked: "about",
    isShown: true,
  },
  {
    type: "Returns",
    text: "RETURNS & EXCHANGES",
    keyToBeChecked: "returnable",
    isShown: true,
  },
  {
    type: "Says",
    text: "NNNOW SAYS",
    keyToBeChecked: "story",
    isShown: true,
  },
];

const MOBILE_ACCORDION = [
  {
    type: "FinerDetails",
    text: "THE FINER DETAILS",
    keyToBeChecked: "finerDetails",
    isShown: true,
    isOpen: false,
  },
  {
    type: "ManufacturerDetails",
    text: "Manufacturer Details",
    keyToBeChecked: "manufacturerDetails",
    isShown: true,
    isOpen: false,
  },
  {
    type: "About",
    text: "About %brand%",
    keyToBeChecked: "about",
    isShown: true,
    isOpen: false,
  },
  {
    type: "Returns",
    text: "RETURNS & EXCHANGES",
    keyToBeChecked: "returnable",
    isShown: true,
    isOpen: false,
  },
  {
    type: "Says",
    text: "NNNOW SAYS",
    keyToBeChecked: "story",
    isShown: true,
    isOpen: false,
  },
];
const ABOUT_TEXT = "Says";
const PDP_CONFIG = {
  MAX_QTY: "You Can Add Max $sellableQuantity Quantity of This Item.",
  OOS_MESSAGE: "Sorry! This Product is Out Of Stock.",
  ADD_TO_BAG_SUCCESS: "We've added this product to your bag",
  ACCORDION_CONFIG: { DESKTOP_ACCORDION, ABOUT_TEXT, MOBILE_ACCORDION },
  PDP_DETAILS_BLOCK: {
    ADD_TO_BAG_STATE: "ADD TO BAG",
    CHECKOUT_STATE: "CHECKOUT",
  },
  PRODUCT_RIGHT_PANEL: {
    ADD_TO_BAG_BUTTON: "ADD TO BAG",
  },
};

export default PDP_CONFIG;



// WEBPACK FOOTER //
// ./src/constants/pdp.js